import React from "react";
import { Award, ShieldCheck, Sparkles, Truck } from "lucide-react";

const ICONS = { Award, ShieldCheck, Sparkles, Truck };

const items = [
  { icon: "Award", label: "Több éves tapasztalat" },
  { icon: "ShieldCheck", label: "Garanciával végzett munka" },
  { icon: "Sparkles", label: "Egyedi megoldások" },
  { icon: "Truck", label: "Háztól-házig szállítás" },
];

export default function TrustBar() {
  return (
    <section
      data-testid="trust-bar"
      className="velvet-cream py-10 md:py-14 border-b border-[#0A1228]/10"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-6">
          {items.map((it, i) => {
            const Icon = ICONS[it.icon];
            return (
              <div
                key={i}
                data-testid={`trust-item-${i}`}
                className="flex items-center gap-4 md:gap-5 group"
              >
                <div className="shrink-0 w-11 h-11 md:w-12 md:h-12 flex items-center justify-center border border-[#B8935A]/50 rounded-full bg-[#FBF9F4] group-hover:bg-[#0A1228] group-hover:border-[#D4B47A] transition-colors">
                  <Icon
                    size={20}
                    className="text-[#1E47A8] group-hover:text-[#D4B47A] transition-colors"
                    strokeWidth={1.5}
                  />
                </div>
                <div className="text-sm md:text-[15px] font-medium text-[#0A1228] leading-snug">
                  {it.label}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
